import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { verifyTotp } from "../../../api/loginApi";
import { completeAuthentication } from "../../../utils/completeAuthentication";
import { ToastContainer, toast } from "react-toastify";
import TotpVerification from "./TotpVerification";
import GPLogo from "../../../assets/images/logo/gp-logo-trans-w100.webp";
import useTranslation from "../../../hooks/useTranslation";
import UserContext from "../../../context/UserContext";
import "../LoginPage.scss";
import "../LoginPageDesktop.scss";
import { useScreenWidth } from "../../../hooks/useScreenWidth";

const TotpVerificationPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useContext(UserContext);
  const screenWidth = useScreenWidth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { t } = useTranslation("loginRelatedPages", true);
  const partialAuth = location.state?.partialAuth;

  // Redirect to login if no partialAuth data
  useEffect(() => {
    if (!partialAuth) {
      navigate("/", { replace: true });
    }
  }, [navigate, partialAuth]);

  // Handle 2FA verification
  const handleVerification = async (totpCode) => {
    try {
      setLoading(true);
      const response = await verifyTotp(partialAuth.userId, totpCode);

      completeAuthentication(response, setUser, navigate, t);
    } catch (error) {
      setLoading(false);
      if (error.response?.status === 401 || error.response?.status === 400) {
        toast.error(t("invalidAuthCode") || "Érvénytelen biztonsági kód");
      } else {
        toast.error(t("verificationError") || "Hitelesítési hiba");
        console.error("TOTP verification error:", error);
      }
    }
  };

  const handleCancel = () => {
    navigate("/", { replace: true });
  };

  // Early return while we wait for the useEffect to run
  if (!partialAuth) {
    return null;
  }

  return (
    // If the screen width is less than 1024px
    screenWidth < 1024 ? (
      // Render the mobile version
      <>
        <div className="container login-page__container">
          <ToastContainer />
          <div className="login-page__form">
            <img src={GPLogo} alt="logo" />
            <TotpVerification
              userId={partialAuth.userId}
              onSuccess={handleVerification}
              onCancel={handleCancel}
              loading={loading}
              setLoading={setLoading}
              error={error}
              setError={setError}
              t={t}
            />
          </div>
        </div>
      </>
    ) : (
      // Otherwise, render the desktop version
      <>
        <div className="base-div">
          <div className="container login-page__container__desktop">
            <ToastContainer />
            <div className="login-page__form__desktop login-page__form__desktop__2fa">
              <div className="login-page__form__desktop__text-wrapper">
                {/*  <img src={GPLogo} alt="logo" className="login__desktop__logo" /> */}
                <TotpVerification
                  userId={partialAuth.userId}
                  onSuccess={handleVerification}
                  onCancel={handleCancel}
                  loading={loading}
                  setLoading={setLoading}
                  error={error}
                  setError={setError}
                  t={t}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  );
};

export default TotpVerificationPage;
